<div class="search-bar">
  <div
    class="col hub-p-0 hub-p-relative search-bar-wrapper"
    hubCloseOnOutsideClick
    (closeChange)="onChangeFocusState(false)">
    <div class="hub-p-relative form-wrapper">
      <i
        class="icon-search hub-p-absolute hub-fs-24 hub-text-lh-1-5 hub-text-lighter hub-align-middle"></i>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <input
          #searchInput
          type="text"
          placeholder="Search OL Platform"
          formControlName="text"
          class="hub-bg-light form-control hub-fs-14"
          [ngClass]="{ blur: !isVisibleSearchPreview }"
          (click)="onChangeFocusState(true)" />
      </form>
      @if (isVisibleSearchPreview) {
        <button
          class="hub-h-100 hub-p-absolute reset-icon-wrapper btn hub-p-0"
          ngbTooltip="Clear"
          placement="right"
          (click)="onResetSearchField($event)">
          <i class="icon-x hub-fs-24 hub-text-lh-1-5 hub-align-middle"></i>
        </button>
      }
    </div>

    @if (isVisibleSearchPreview) {
      <div
        class="hub-border hub-rounded hub-px-1 hub-w-100 hub-p-absolute hub-bg-white hub-overflow-auto hub-max-vh-50 search-preview">
        <div
          class="hub-overflow-auto hub-tt-capitalize hub-d-flex hub-align-items-center hub-pt-1-5 hub-pb-1 categories">
          <ng-container
            [ngTemplateOutlet]="categoryTmp"
            [ngTemplateOutletContext]="{
              title: 'all categories',
              categoryType: categoryTypes.Any,
            }" />

          <ng-container
            [ngTemplateOutlet]="categoryTmp"
            [ngTemplateOutletContext]="{ title: 'projects', categoryType: categoryTypes.Project }" />

          <ng-container
            [ngTemplateOutlet]="categoryTmp"
            [ngTemplateOutletContext]="{ title: 'modules', categoryType: categoryTypes.Module }" />

          <ng-container
            [ngTemplateOutlet]="categoryTmp"
            [ngTemplateOutletContext]="{ title: 'assets', categoryType: categoryTypes.Asset }" />

          <ng-container
            [ngTemplateOutlet]="categoryTmp"
            [ngTemplateOutletContext]="{
              title: 'contracts',
              categoryType: categoryTypes.Contract,
            }" />

          <ng-container
            [ngTemplateOutlet]="categoryTmp"
            [ngTemplateOutletContext]="{ title: 'methods', categoryType: categoryTypes.Method }" />

          <ng-container
            [ngTemplateOutlet]="categoryTmp"
            [ngTemplateOutletContext]="{
              title: 'my bookmarks',
              categoryType: categoryTypes.Bookmark,
            }" />
        </div>

        @if ((searchStore.searchResults$ | async)!.length > 0) {
          <div class="results">
            @if ((projectsResults$ | async)!.length > 0) {
              <ng-container
                [ngTemplateOutlet]="resultSectionTmp"
                [ngTemplateOutletContext]="{
                  title: 'projects',
                  results: (projectsResults$ | async),
                  categoryType: categoryTypes.Project,
                  baseUrl: 'projects',
                }" />
            }

            @if ((modulesResults$ | async)!.length > 0) {
              <ng-container
                [ngTemplateOutlet]="resultSectionTmp"
                [ngTemplateOutletContext]="{
                  title: 'modules',
                  results: (modulesResults$ | async),
                  categoryType: categoryTypes.Module,
                  baseUrl: 'modules',
                }" />
            }

            @if ((assetsResults$ | async)!.length > 0) {
              <ng-container
                [ngTemplateOutlet]="resultSectionTmp"
                [ngTemplateOutletContext]="{
                  title: 'assets',
                  results: (assetsResults$ | async),
                  categoryType: categoryTypes.Asset,
                  baseUrl: 'modules',
                }" />
            }

            @if ((contractsResults$ | async)!.length > 0) {
              <ng-container
                [ngTemplateOutlet]="resultSectionTmp"
                [ngTemplateOutletContext]="{
                  title: 'contracts',
                  results: (contractsResults$ | async),
                  categoryType: categoryTypes.Contract,
                  baseUrl: 'projects',
                }" />
            }

            @if ((methodsResults$ | async)!.length > 0) {
              <ng-container
                [ngTemplateOutlet]="resultSectionTmp"
                [ngTemplateOutletContext]="{
                  title: 'methods',
                  results: (methodsResults$ | async),
                  categoryType: categoryTypes.Method,
                  baseUrl: 'projects',
                }" />
            }
          </div>
        } @else {
          @if (isVisibleEmptyResultsState) {
            <h3 class="hub-fs-16 hub-text-lh-150 hub-d-block hub-my-1 hub-tt-capitalize">
              no results found
            </h3>
          }
        }

        @if (!((searchStore.searchResults$ | async)!.length > 0)) {
          <div class="hub-pb-1-5 recent-history">
            <div
              class="hub-pb-0-5 hub-d-flex hub-justify-content-between hub-align-items-center recent-header">
              <p class="hub-fw-bolder hub-tt-capitalize hub-text-lighter hub-m-0">recent</p>
              <button
                class="hub-cursor-p hub-tt-uppercase hub-text-grey btn clear-recent-history-btn"
                (click)="resetRecentHistory($event)">
                clear
              </button>
            </div>

            @if (recentHistory!.length > 0) {
              <div class="recent-list">
                @for (recentObj of recentHistory; track recentObj) {
                  <p
                    class="hub-d-block hub-tt-capitalize recent hub-cursor-p"
                    (click)="searchRecent(recentObj)">
                    {{ recentObj.text }}, {{ recentObj.category }}
                  </p>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>

<ng-template #categoryTmp let-title="title" let-categoryType="categoryType">
  <button
    class="hub-text-nowrap hub-fs-14 hub-d-flex hub-align-items-center hub-justify-content-between btn hub-shadow-none hub-tt-capitalize hub-fw-normal cursor-p hub-border hub-border-secondary hub-rounded-pill hub-mx-0-25 hub-py-0 hub-px-0-5 category"
    [ngClass]="{
      'hub-bg-secondary hub-text-white': activeCategoryType === categoryType,
      'hub-ml-auto': categoryType === categoryTypes.Bookmark,
    }"
    (click)="selectCategory(categoryType)">
    <ng-container
      [ngTemplateOutlet]="categoryIconTmp"
      [ngTemplateOutletContext]="{ categoryType: categoryType }" />

    <p class="b-inline-block hub-m-0 hub-ml-0-25">{{ title }}</p>
  </button>
</ng-template>

<ng-template
  #resultSectionTmp
  let-title="title"
  let-results="results"
  let-categoryType="categoryType"
  let-baseUrl="baseUrl">
  <div class="hub-d-flex hub-flex-column hub-tt-capitalize hub-my-1">
    <div class="hub-d-flex hub-align-items-center">
      <ng-container
        [ngTemplateOutlet]="categoryIconTmp"
        [ngTemplateOutletContext]="{ categoryType: categoryType }" />
      <h3 class="hub-ml-0-25 hub-d-inline hub-text-lighter hub-m-0 hub-text-lh-150 hub-fs-16">
        {{ title }}
      </h3>
    </div>
    <!-- TODO: do search results as links, which redirects to Hub Entity overview page -->
    @for (res of results; track res) {
      <a
        [routerLink]="
          navigateToEntityPage(
            baseUrl,
            res.data.id,
            categoryType,
            res.additionalInfo.moduleId || res.additionalInfo.projectId,
            res.additionalInfo.contractId
          )
        "
        (click)="isVisibleSearchPreview = false"
        class="hub-text-lighter hub-mt-0-25 hub-d-block hub-td-none hub-fs-14 hub-text-lh-1-75 hub-fw-bolder">
        {{ res.data.name }}
        @if (categoryType === categoryTypes.Asset && res.additionalInfo?.path) {
          <span class="hub-fs-12 hub-text-lighter">(path: {{ res.additionalInfo?.path }})</span>
        }
      </a>
    }
  </div>
</ng-template>

<ng-template #categoryIconTmp let-categoryType="categoryType">
  @switch (categoryType) {
    @case (categoryTypes.Bookmark) {
      <hub-icon [icon]="'small icon-bookmark-empty'" />
    }
    @case (categoryTypes.Project) {
      <hub-icon [icon]="'small icon-projects'" />
    }
    @case (categoryTypes.Module) {
      <hub-icon [icon]="'small icon-modules'" />
    }
    @case (categoryTypes.Asset) {
      <hub-icon [icon]="'small icon-assets'" />
    }
    @case (categoryTypes.Contract) {
      <hub-icon [icon]="'small icon-contracts'" />
    }
    @case (categoryTypes.Method) {
      <hub-icon [icon]="'small icon-methods'" />
    }
    @case (categoryTypes.Resource) {
      <hub-icon [icon]="'small icon-attachments'" />
    }
    @case (categoryTypes.Service) {
      <hub-icon [icon]="'small icon-services'" />
    }
  }
</ng-template>
